import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const addDeductItem = async (data) => {
  try {
    console.log(`deduction item`, data);
    return await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/deductionItem`,
      data,
    );
  } catch (e) {
    console.error(e);
  }
};

export const updateDeductItem = async (data) => {
  try {
    console.log('deduction item', data);
    return await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/deductionItem`,
      data,
    );
  } catch (e) {
    console.error(e);
  }
};

export const searchDeductItems = async (data) => {
  try {
    console.log(`searchDeductItems`, data);
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/deductionItem/search`,
      data,
    );
    console.log(`item serch res`, response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
export const deductionItemById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/deductionItem/searchByItemId?itemId=${id}`,
    );
    console.log(`deductionItemById`, response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const deductionItemByName = async (name) => {
  try {
    const response = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.TRANSPORT}/deductionItem/searchByItemName?itemName=${name}`,
    );
    console.log(`deductionItemById`, response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const taxdropdown = async () => {
  try{
    const response = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.FINANCE}/tax/tax/dropdown`,
    )
    console.log("Resposne:",response);
    return response.data.map((item) => {
      let data = {
        key: item.id,
        text: item.text,
        value: item.value,
      };
      return data;
    });
  }catch (e){
    console.error(e);
  }
}

export const taxRate = async (taxId) => {
  try {
    const response = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.FINANCE}/tax/tax/rate/${taxId}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};


export const CalculateTaxAmountOfItem = async(data) => {
  try{
    return await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/deductionItem/calculate`,
        data,
    );
  }catch (error) {
    console.error(error);
  }
}